<script>
  import { formatRichText } from "../../utils/utilities";

  export let text;
  export let showDot;

  async function wait() {
    if (!showDot) return true;
    await new Promise((resolve) => setTimeout(resolve, 2000));
    return true;
  }
</script>

<div class="chatwith-bubble-bot">
  {#await wait()}
    <div class="chatwith-bubble-bot-dots">
      <span class="chatwith-bubble-bot-dot" />
      <span class="chatwith-bubble-bot-dot" />
      <span class="chatwith-bubble-bot-dot" />
    </div>
  {:then v}
    {@html formatRichText(text)}
  {/await}
</div>

<!-- Rich-text and link-chip styles live in scss/components/chat.scss so they are
     shared with the freetext bubble and applied inside {@html} content. -->
